import React, { useMemo } from 'react';
import { ApolloClient, ApolloProvider, createHttpLink, InMemoryCache } from '@apollo/client';
import { timeoutLink } from 'Utils/ProfileGraphQLPolicy';
const OneGraphProvider = ({ oneGraphApiKey, oneGraphApiUrl, countryCode, ctk, prforceGroups, children }) => {
    const client = useMemo(() => new ApolloClient({
        cache: new InMemoryCache(),
        link: timeoutLink.concat(createHttpLink({
            uri: oneGraphApiUrl,
            credentials: 'include',
            headers: {
                'Indeed-API-Key': oneGraphApiKey,
                'indeed-ctk': ctk,
                'indeed-co': countryCode,
                ...(prforceGroups ? { 'indeed-prforce-groups': prforceGroups } : {})
            }
        }))
    }), [oneGraphApiUrl, oneGraphApiKey, countryCode, ctk, prforceGroups]);
    return React.createElement(ApolloProvider, { client: client }, children);
};
export default OneGraphProvider;
